import { createI18n } from 'vue-i18n'

import cs from "@/locales/langs/cs.json";

var mainLang = 'cs';

export default createI18n({
    locale: (localStorage.getItem('lang') || mainLang), // set locale
    fallbackLocale: mainLang,
    messages: {
        cs: cs,
    },
    datetimeFormats: {
        cs: {
            short: {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            },
            long: {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
            }
        },
        pl: {
            short: {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit"
            },
        }
    },
    pluralizationRules: {
        cs: function(choice, choicesLength) {
            if (choice == 0) {
                return 0;
            } else if (choice == 1) {
                return 1;
            } else if (choice >= 2 && choice <= 4) {
                return 2;
            }
            return choicesLength < 4 ? 2 : 3;
        },
    }
});
